export default __webpack_public_path__ + "static/d13-abed7adda915a41156c1b63b459c2955.png";